import { getAccessToken } from './client.js';

/**
 * Downloads a file the API serves behind the session.
 *
 * An <a href> cannot send the Authorization header, so the request would arrive
 * unauthenticated. The bytes are fetched with the token, turned into an object
 * URL and handed to a synthetic click, and the URL is revoked straight away so
 * the blob is not held for the life of the page (as AccountDocsTab does).
 */
export async function downloadFile(apiPath: string, filename: string): Promise<void> {
  const res = await fetch(`/api${apiPath}`, {
    headers: { Authorization: `Bearer ${getAccessToken() ?? ''}` },
  });
  if (!res.ok) throw new Error(`The file could not be downloaded (${res.status}).`);
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
